/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    Auftraggeber,
    AuftraggeberSucheParams,
    AuftraggeberSucheResponse,
    TemplateSucheParams,
    TemplateSucheResponse
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class AuftraggeberApiService {
  private readonly http = inject(HttpClient);
/**
 * Ermöglicht es einen einzelnen Auftraggeber anhand der Trustlog-Kennung abzurufen.
 * @summary Einzelnen Auftraggeber anhand Trustlog-Kennung abrufen
 */
 auftraggeberByTrustlogKennung<TData = Auftraggeber>(trustlogAgKennung: string, options?: HttpClientBodyOptions): Observable<TData>;
 auftraggeberByTrustlogKennung<TData = Auftraggeber>(trustlogAgKennung: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 auftraggeberByTrustlogKennung<TData = Auftraggeber>(trustlogAgKennung: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  auftraggeberByTrustlogKennung<TData = Auftraggeber>(
    trustlogAgKennung: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/auftraggeber/${trustlogAgKennung}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/auftraggeber/${trustlogAgKennung}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/auftraggeber/${trustlogAgKennung}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Ermöglicht es Metadaten für gültige Templates eines Auftraggebers, identifiziert anhand seiner Trustlog-Kennung, abzurufen.
 * @summary Metadaten aller Bürgschaftsvorlagen für einen Auftraggeber abrufen
 */
 templateSuche<TData = TemplateSucheResponse>(params: TemplateSucheParams, options?: HttpClientBodyOptions): Observable<TData>;
 templateSuche<TData = TemplateSucheResponse>(params: TemplateSucheParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 templateSuche<TData = TemplateSucheResponse>(params: TemplateSucheParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  templateSuche<TData = TemplateSucheResponse>(
    params: TemplateSucheParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/auftraggeber/templates`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/auftraggeber/templates`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/auftraggeber/templates`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Ermöglicht es den Inhalt einer einzelnen Bürgschaftsvorlage, identifiziert anhand dessen Trustlog-Kennung, in Form einer PDF-Datei (Base64-kodiert) abzurufen.
 * @summary PDF einer einzelnen Bürgschaftsvorlage anhand dessen Trustlog-Kennung abrufen
 */
 templateContent(trustlogTemplateKennung: string, options?: HttpClientBodyOptions): Observable<Blob>;
 templateContent(trustlogTemplateKennung: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 templateContent(trustlogTemplateKennung: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  templateContent(
    trustlogTemplateKennung: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/api/auftraggeber/templates/${trustlogTemplateKennung}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/auftraggeber/templates/${trustlogTemplateKennung}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/auftraggeber/templates/${trustlogTemplateKennung}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
/**
 * Suche Auftraggeber anhand eines Namens(teils) und (optional) einer PLZ.
 * @summary Suche Auftraggeber anhand eines Namens(teils) bzw. PLZ
 */
 auftraggeberSuche<TData = AuftraggeberSucheResponse>(params: AuftraggeberSucheParams, options?: HttpClientBodyOptions): Observable<TData>;
 auftraggeberSuche<TData = AuftraggeberSucheResponse>(params: AuftraggeberSucheParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 auftraggeberSuche<TData = AuftraggeberSucheResponse>(params: AuftraggeberSucheParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  auftraggeberSuche<TData = AuftraggeberSucheResponse>(
    params: AuftraggeberSucheParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/auftraggeber/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/auftraggeber/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/auftraggeber/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

